export default function SafetySection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Is Itaobuy Spreadsheet Safe?
          </h2>
          <p className="mt-5 text-foreground-600 text-base leading-relaxed">
            Yes, the <strong>itaobuy spreadsheet</strong> system is designed with transparency and buyer protection in mind. However, like all cross-border sourcing platforms, users should be aware of potential shipping delays, supplier variation risks, and payment verification needs.
          </p>
          <p className="mt-3 text-foreground-600 text-base leading-relaxed">
            We recommend using verified agents and checking QC images before shipping to ensure a smooth and secure sourcing experience with the itaobuy spreadsheet system.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 mt-7 px-7 py-3 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Explore Itaobuy Spreadsheet Now
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}